import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/azu.jpg"


export const AZU = () => {    

    return (
        <SongLinks 
        title={"Anleitung zur Unsichtbarkeit"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/2bltOEwL8LgExGReZmZBvm"}
        spotifyPresaveLink={"https://add-it.feiyr.com/MondWild/Anleitung%20zur%20Unsichtbarkeit"}
        appleMusicLink={"https://music.apple.com/de/album/anleitung-zur-unsichtbarkeit-single/1893383915"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=dUZGW-atIng&si=d07cm4FtY0gBF4pM"}
        youtubeLink={"https://youtu.be/8PuXfePjPgw"}
        tidalLink={"https://tidal.com/album/512677566"}
        amazonMusicLink={"https://www.amazon.de/music/player/albums/B0GVTDK959"}
        bandcampLink={"https://mondwild.bandcamp.com/track/anleitung-zur-unsichtbarkeit"}
        releaseDate={"2026-04-24T00:00:00+02:00"}/>
    );
}